import AnnotationOverlays from './AnnotationOverlays';
import { RenderAdapter } from '~/viewportGrid/adapters/types';
import { useCanvasFrameGeometryOf, usePlaneViewOf } from '../usePlaneViewOf';

interface TileAnnotationMountProps {
    renderer: RenderAdapter;
}

/**
 * Mounts the annotation overlays (measurements, line profiles and regions)
 * over one grid tile, driven by the tile's engine view.
 * Renders nothing for non-engine renderers (the mock adapters).
 */
export default function TileAnnotationMount({
    renderer,
}: TileAnnotationMountProps) {
    const view = usePlaneViewOf(renderer);
    const frame = useCanvasFrameGeometryOf(renderer);
    if (!view) {
        return null;
    }
    return <AnnotationOverlays view={view} frame={frame} />;
}
